import React,{useState} from 'react'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Link, useLocation} from 'react-router-dom'
import classes from './Navbar.module.css'
import SidebarComponent from './SidebarComponent';
import logo from '../Assets/mtn.png'
import right_logo from '../Assets/logo.png'
import Subscribe from '../Pages/Subscribe';
import { v4 as uuidv4 } from 'uuid';
import { generateRandomString } from './RandomStringGenerator';


const Navbar = ({Categories}) => {

  const {pathname} = useLocation()


  const params = new URLSearchParams(window.location.search)
  const extId = params.get('ext_ref') || generateRandomString()


  const [showSideBar,setShowSideBar] = useState(false);

  const handleToggleSideBar=()=>{
    setShowSideBar(!showSideBar)
  }

  return (
    <div className={classes.container}>
      <nav className={classes.nav}>
        <div className={classes.logo}>
          {/* <Link to={`/home`}> */}
            <img src={logo} alt="..." className={classes.img_logo}/>
          {/* </Link> */}
        </div>
        <div className={classes.categories}>
        {
          pathname !== '/mis-data' && pathname !== '/subscribe' &&  pathname !== '/promotion-data' &&
          <div className={classes.category}>
                <Link to={`/home?ext_ref=${extId}`}>Home</Link>
              </div>
        }
          {
            Categories &&  Categories.map((category,idx)=>(
              <div className={classes.category} key={idx}>
                <Link to={`/videos/${category}`}>{category}</Link>
              </div>
            ))
          }

          {
            pathname !== '/mis-data' && pathname !== '/subscribe' &&  pathname !== '/promotion-data' &&
          
          <div className={classes.category}>
                <Link to={`/profile?ext_ref=${extId}`}>Profile</Link>
              </div>
            }
          {
            pathname !== '/mis-data' && pathname !== '/subscribe' &&  pathname !== '/promotion-data' &&
          
          <div className={classes.category}>
                <Link to={`/faq`}>Faq's</Link>
              </div>
            }
          <div className={classes.logo_right}>
            <img src={right_logo} alt="..." className={classes.img_logo}/>
        </div>
        </div>
       
       {
        pathname !== '/mis-data' && pathname !== '/subscribe' &&  pathname !== '/promotion-data' &&
        <div className={classes.icon}>
        <i className="pi pi-sliders-h" onClick={handleToggleSideBar} style={{cursor:'pointer'}}></i>
        </div>
       }
      </nav>
      <SidebarComponent visible = {showSideBar} handle ={handleToggleSideBar} categories={Categories}/>
      {/* <ToastContainer/> */}
    </div>
  )
}

export default Navbar
